import { styled } from '@mui/system';
import { Grid, Box } from '@mui/material';

// Landing Bar styling
export const LandingBarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(0, 5),
  backgroundColor: '#fff',
  boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 2),
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

// Logo styling
export const LandingLogo = styled('img')(({ theme }) => ({
  width: '100px',
  height: '100px',
  objectFit: 'contain',
  [theme.breakpoints.down('md')]: {
    width: '100px',
    height: '100px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '80px',
    height: '80px',
  },
}));

// Container styling
export const StyledContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

// Hero Section styling
export const HeroSection = styled(Box)(({ theme }) => ({
  minHeight: '80vh',
  display: 'flex',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    textAlign: 'center',
    padding: theme.spacing(3),
    minHeight: '100vh',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(3),
    minHeight: '60vh',
  },
}));

// Hero Text styling
export const HeroText = styled(Box)(() => ({
  maxWidth: '600px',
}));

export const BrandSection = styled(Box)(({ theme }) => ({
  minHeight: '50vh',
  width: '100%',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#fff',
  padding: theme.spacing(3), 
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
}));


// Brand Image styling
export const BrandImage = styled('img')(({theme}) => ({
  width: '130px',
  height: '70px',
  [theme.breakpoints.down('sm')]: {
    width: '130px',
    height: '70px'
  },
}));

// Why Choose Section styling
export const WhyChooseSection = styled(Box)(({ theme }) => ({
  minHeight: '50vh',
  display: 'flex',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(5),
    minHeight: '100vh',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: '70vh',
  },
}));

// Why Choose Grid styling
export const WhyChooseGrid = styled(Grid)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridGap: theme.spacing(1),
  width: '100%',
  color: '#E17244',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

// Why Choose List Item styling
export const WhyChooseItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

// Why Choose Image styling
export const WhyChooseImage = styled('img')(({ theme }) => ({
  width: '25px',
  height: '25px',
  marginRight: theme.spacing(0.75),
  marginBottom: theme.spacing(2.5),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(0.5)
  },
}));

// Workflow Section styling
export const WorkflowSection = styled(Box)(({ theme }) => ({
  minHeight: '50vh',
  display: 'flex',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    textAlign: 'center',
    padding: theme.spacing(3),
    minHeight: '70vh',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: '60vh',
  },
}));

// Footer Section styling
export const FooterSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#042D77',
  color: '#ffffff',
  textAlign: 'center',
}));

// Image Styling
export const LandingImage = styled('img')(({ theme }) => ({
  width: '450px',
  height: '450px',
  borderRadius: '12px',
  objectFit: 'contain',
  [theme.breakpoints.down('sm')]: {
    width: '300px',
    height: '300px',
  },
}));

// Popup Overlay styling
export const PopupOverlay = styled(Box)(({ show }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: show ? 'blur(1px)' : 'none',
  visibility: show ? 'visible' : 'hidden',
  opacity: show ? 1 : 0,
  transition: 'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out',
  zIndex: 1,
}));

// Popup Container styling
export const PopupContainer = styled(Box)(({ theme, show }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '580px',
  height: '480px',
  backgroundColor: '#fff',
  borderRadius: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  opacity: show ? 1 : 0,
  visibility: show ? 'visible' : 'hidden',
  transition: 'opacity 1s ease-in-out, visibility 1s ease-in-out',
  [theme.breakpoints.down('sm')]: {
    width: '80%',
  },
  [theme.breakpoints.down('md')]: {
    width: '75%',
  }
}));

// Popup Image styling
export const PopupImageBox = styled('img')(({ theme }) => ({
  width: '530px',
  height: '300px',
  borderRadius: '12px',
  objectFit: 'contain',
  [theme.breakpoints.down('md')]: {
    width: '530px',
    height: '300px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '250px',
    height: '250px',
  },
}));

// Popup Box styling
export const StyledPopupBox = styled(Box)(() => ({
  borderRadius: '12px',
  width: '580px',
  height: '480px',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  padding: '20px 15px',
}));

// Floating Chat Button Image styling
export const FloatingChatImage = styled('img')(() => ({
  width: '50px',
  height: '50px',
  objectFit: 'contain',
}));
